<div class="context-button" id="context-button-{{id}}" (click)='showMenu()'><div inlineSVG="assets/images/dot_menu.svg"></div></div>
<div id="context-container-{{id}}">
  <div class="context-button-popup-overlay" id="context-button-popup-overlay-{{id}}" (click)='hideMenu()'>
    <div class="context-button-popup" id="context-button-popup-{{id}}">
      <ng-content></ng-content>
    </div>
  </div>
</div>